import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import MaintenanceBanner from './MaintenanceBanner';
import { useAuthContext } from '../../contexts/AuthContext';

const AuthScreen = ({ children }) => {
  const { isLoading, error, clearError } = useAuthContext();

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center max-w-md">
          <h2 className="text-2xl font-bold text-red-500 mb-4">Authentication Error</h2>
          <p className="text-gray-300 mb-4">{error.message}</p>
          <div className="space-y-3">
            <button
              className="block w-full px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
            <button
              className="block w-full px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded transition-colors"
              onClick={() => {
                clearError();
                window.location.href = '/';
              }}
            >
              Clear Auth Error
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return <LoadingSpinner message="Initializing authentication..." />;
  }

  return children;
};

// The maintenance bar sits above every state (signed out, auth error, loading, and the signed-in
// app), because during planned downtime a signed-in user lands on an in-app error, not the login.
const AuthWrapper = ({ children }) => (
  <>
    <MaintenanceBanner />
    <AuthScreen>{children}</AuthScreen>
  </>
);

export default AuthWrapper;
